<template>
  <div
    class="page-wrap"
    :class="{ 'page-wrap--celebration': celebrating }"
    :style="{ height: viewportHeight }"
  >
    <div class="bg-decor" aria-hidden="true">
      <div class="decor-item decor-outline decor-outline-gift-one">
        <svg viewBox="0 0 100 100">
          <rect x="20" y="42" width="60" height="48" rx="4" />
          <rect x="14" y="30" width="72" height="16" rx="3" />
          <path
            d="M50 30v60M50 30Q36 14 26 24q10 8 24 6m0 0q14-16 24-6-10 8-24 6"
          />
        </svg>
      </div>
      <div class="decor-item decor-outline decor-outline-card-one">
        <svg viewBox="0 0 120 90">
          <rect x="10" y="15" width="100" height="60" rx="6" />
          <circle cx="32" cy="42" r="7" />
          <path d="M50 38h50M50 52h36" />
        </svg>
      </div>
      <div class="decor-item decor-outline decor-outline-gift-two">
        <svg viewBox="0 0 100 100">
          <rect x="20" y="42" width="60" height="48" rx="4" />
          <rect x="14" y="30" width="72" height="16" rx="3" />
          <path
            d="M50 30v60M50 30Q36 14 26 24q10 8 24 6m0 0q14-16 24-6-10 8-24 6"
          />
        </svg>
      </div>
      <div class="decor-item decor-outline decor-outline-card-two">
        <svg viewBox="0 0 120 90">
          <rect x="10" y="15" width="100" height="60" rx="6" />
          <circle cx="32" cy="42" r="7" />
          <path d="M50 38h50M50 52h36" />
        </svg>
      </div>
      <div class="decor-item decor-outline decor-outline-gift-small">
        <svg viewBox="0 0 100 100">
          <rect x="20" y="42" width="60" height="48" rx="4" />
          <rect x="14" y="30" width="72" height="16" rx="3" />
          <path d="M50 30v60" />
        </svg>
      </div>
      <div class="decor-item decor-outline decor-outline-card-small">
        <svg viewBox="0 0 120 90">
          <rect x="10" y="15" width="100" height="60" rx="6" />
          <circle cx="32" cy="42" r="7" />
          <path d="M50 38h50M50 52h36" />
        </svg>
      </div>
    </div>
    <transition name="flow-step" mode="out-in">
      <component
        v-if="step === 'formBasic'"
        key="step-one"
        :is="currentView"
        v-model="form"
      ></component>
      <Card
        v-else-if="isStageTwo"
        key="step-two"
        class="card-wrapper--stage-two"
        :showBtn="false"
        :flowProxy="true"
      >
        <div
          class="reference-stage-two-heading"
          :class="{ 'paypal-stage-heading': step === 'paypalForm' }"
        >
          <div v-if="step !== 'uploadPic'" class="reference-success">
            <span class="reference-check"
              ><svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M4 12 L10 18 L20 6" /></svg
            ></span>
            <div>
              <strong>{{ $t("thanks.title") }}</strong>
              <p v-html="$t('showGiftCard.title')"></p>
            </div>
          </div>
          <div
            v-if="step !== 'uploadPic' && step !== 'paypalForm'"
            class="reference-step-heading"
          >
            <div>
              <p class="card-title" v-html="$t('showGiftCard.text')"></p>
            </div>
          </div>
        </div>
        <transition name="flow-substep" mode="out-in">
          <component
            :key="step"
            :is="currentView"
            v-model="form"
            :embedded="true"
            @prevStep="prevStep"
          ></component>
        </transition>
      </Card>
      <component
        v-else
        :key="step"
        :is="currentView"
        v-model="form"
      ></component>
    </transition>
    <van-overlay :show="loading" :custom-style="{ background: '#f0f0f0aa' }">
      <van-loading size="60px" color="#f4a300" />
    </van-overlay>
    <div v-if="celebrating" class="celebration-confetti" aria-hidden="true">
      <span
        v-for="item in confetti"
        :key="item.id"
        :class="celebrationType"
        :style="item.style"
      ></span>
    </div>
  </div>
</template>

<script>
import FormBasic from "./components/formBasic.vue";
import ShowGiftCard from "./components/showGiftCard.vue";
import Star from "./components/star.vue";
import EnsureEmail from "./components/ensureEmail.vue";
import ChannelSelect from "./components/channelSelect.vue";
import UploadPic from "./components/uploadPic.vue";
import CityForm from "./components/cityForm.vue";
import PaypalForm from "./components/paypalForm.vue";
import DefaultPaypalForm from "./components/defaultPaypalForm.vue";
import ThanksAll from "./components/thanks-all.vue";
import Thanks from "./components/thanks.vue";
import Card from "@/components/card.vue";
import { postUpdateStep, getViewer } from "@/api/portal";

export default {
  components: {
    Card,
    FormBasic,
    ShowGiftCard,
    Star,
    EnsureEmail,
    ChannelSelect,
    UploadPic,
    CityForm,
    PaypalForm,
    ThanksAll,
    Thanks,
    DefaultPaypalForm,
  },
  data() {
    return {
      step: "",
      viewportHeight: 0,
      loading: false,
      celebrating: false,
      celebrationType: "confetti",
      selectedGift: null,
      confetti: [],
      form: {
        screenshots: [],
        fileList: [],
        currentIndex: 0,
      },
    };
  },
  computed: {
    currentView() {
      const views = {
        formBasic: "FormBasic",
        showGiftCard: "ShowGiftCard",
        channelSelect: "ChannelSelect",
        uploadPic: "UploadPic",
        cityForm: "CityForm",
        paypalForm: "PaypalForm",
        thanksAll: "ThanksAll",
        thanks: "Thanks",
      };
      return views[this.step];
    },
    isStageTwo() {
      return [
        "showGiftCard",
        "uploadPic",
        "channelSelect",
        "cityForm",
        "paypalForm",
      ].includes(this.step);
    },
  },
  mounted() {
    this.step = "formBasic"; // this.$route.query.step || 'formBasic';
    this.updateViewportHeight();
    if (this.$store.getters.form) {
      this.form = this.$store.getters.form;
    }
    window.addEventListener("resize", this.updateViewportHeight);
    getViewer();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateViewportHeight);
  },
  methods: {
    updateViewportHeight() {
      this.viewportHeight = window.innerHeight + "px";
    },
    prevStep(step, data) {
      this.step = step;
      this.celebrating = false;
    },
    changeStep(step, data) {
      this.step = step;
      if (step === "showGiftCard") this.celebrate("confetti");
      else if (step === "thanksAll" || step === "thanks")
        this.celebrate("ribbon");
      else this.celebrating = false;
      // this.loading = true;
      // if(data){
      //   postUpdateStep({current_step:step,order_id:this.form.order_id,data}).then(res => {
      //     setTimeout(_ => {
      //       this.loading = false;
      //       this.step = step;
      //     }, 2000);
      //   });
      // }else{
      //   setTimeout(_ => {
      //     this.loading = false;
      //     this.step = step;
      //   }, 2000);
      // }
    },
    celebrate(type) {
      const colors = [
        "#16a34a",
        "#0ea5e9",
        "#7c3aed",
        "#f59e0b",
        "#ef4444",
        "#ec4899",
      ];
      this.celebrationType = type;
      const count = type === "ribbon" ? 30 : 24;
      const maxDelay = type === "ribbon" ? 1.6 : 0.5;
      this.confetti = Array.from({ length: count }, (_, id) => ({
        id,
        style: {
          left: `${Math.random() * 100}%`,
          backgroundColor: colors[Math.floor(Math.random() * colors.length)],
          animationDelay: `${Math.random() * maxDelay}s`,
          transform: `rotate(${Math.random() * 180}deg)`,
        },
      }));
      this.celebrating = true;
      window.setTimeout(
        () => {
          this.celebrating = false;
        },
        type === "ribbon" ? 3200 : 2000,
      );
    },
  },
};
</script>

<style>
.van-loading {
  width: 60px;
  height: 60px;
  top: calc(50% - 60px);
  margin: auto;
}
.page-wrap {
  width: 100%;
  height: 100%;
  background-color: #5e5e5e;
  position: relative;
  .ant-form label {
    font-size: 15px;
    font-weight: 500;
  }
  .ant-input:focus {
    border: 1px solid #ffd814;
    box-shadow: none;
  }
  .ant-input:hover {
    border: 1px solid #ffd814;
    box-shadow: none;
  }
}
</style>
